module.exports = __webpack_public_path__ + "static/media/greyClose.921bdd27.svg";